import React from 'react'

const AutomationOptionsKnxOrIotSensors = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none" className={className}>
    <path
      d="M40.86 1H7.32C3.82956 1 1 3.82956 1 7.32V40.86C1 44.3504 3.82956 47.18 7.32 47.18H40.86C44.3504 47.18 47.18 44.3504 47.18 40.86V7.32C47.18 3.82956 44.3504 1 40.86 1Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M24.0897 30.0001C27.3537 30.0001 29.9997 27.3541 29.9997 24.0901C29.9997 20.8261 27.3537 18.1801 24.0897 18.1801C20.8257 18.1801 18.1797 20.8261 18.1797 24.0901C18.1797 27.3541 20.8257 30.0001 24.0897 30.0001Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M34.4297 20.09C34.9509 20.6093 35.3646 21.2265 35.6468 21.906C35.929 22.5856 36.0742 23.3141 36.0742 24.05C36.0742 24.7858 35.929 25.5144 35.6468 26.1939C35.3646 26.8735 34.9509 27.4906 34.4297 28.01"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M38.2207 16.34C40.2664 18.4005 41.4145 21.1864 41.4145 24.09C41.4145 26.9936 40.2664 29.7794 38.2207 31.84"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M13.75 28.09C13.2288 27.5707 12.8152 26.9536 12.533 26.274C12.2507 25.5944 12.1055 24.8659 12.1055 24.13C12.1055 23.3942 12.2507 22.6656 12.533 21.9861C12.8152 21.3065 13.2288 20.6894 13.75 20.17"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M9.95938 31.84C7.91366 29.7794 6.76562 26.9936 6.76562 24.09C6.76562 21.1864 7.91366 18.4005 9.95938 16.34"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)

export default AutomationOptionsKnxOrIotSensors
